import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

const PATH_TEMPLATE =
  '/workflows/user-workflows/{userWorkflowId}/questionnaires/{questionnaireId}/generated-pdfs/{pdfTemplateId}';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['GET'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const getFormPDFDocumentId = async ({ userWorkflowId, questionnaireId, pdfTemplateId }: Input): Promise<Output> => {
  const response = await noodleApiClient.get(
    `/workflows/user-workflows/${userWorkflowId}/questionnaires/${questionnaireId}/generated-pdfs/${pdfTemplateId}`,
  );
  return response.data;
};

export default getFormPDFDocumentId;
